import { render } from "./ChessPage.vue?vue&type=template&id=7e635236"
import script from "./ChessPage.vue?vue&type=script&lang=js"
export * from "./ChessPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\CONSULT\\PROJECTS\\_HTML\\baden-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__